export default __webpack_public_path__ + "static/media/BeIcon2.e743fe57.svg";